<svg
  class="space-open-door-icon"
  viewBox="0 0 221 221"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  role="img"
  aria-label="Open Door Icon"
>
  <rect x="20.7188" y="13.8119" width="178.626" height="177.073" rx="4.81965" [attr.fill]="color" />
  <rect x="34.8213" y="27.9139" width="150.422" height="148.855" rx="4.81965" fill="white" />
  <path
    d="M150.523 46.145L35.6159 20.0641C32.6003 19.3796 29.7295 21.6719 29.7295 24.7642V173.48C29.7295 175.708 31.2571 177.646 33.4238 178.166L148.331 205.759C151.362 206.487 154.276 204.19 154.276 201.073V50.8451C154.276 48.5943 152.718 46.6432 150.523 46.145Z"
    [attr.fill]="color"
  />
</svg>
